/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KS_customerservice_Service_Data_Role {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
